const baseURL = window.localStorage.getItem('base_url')?.toString();
const mobileNegotiationURL = window.localStorage.getItem('mobile_negotiation_url')?.toString();
let Constants = {
  MAINURL: baseURL + '/api',
  HUBURL: baseURL,
  HUBURL2: mobileNegotiationURL,
  //kerman main
  // MAINURL: "https://asayarapi.kmu.ac.ir/api/",
  // HUBURL: "https://asayarapi.kmu.ac.ir",
  // HUBURL2: "https://asayarapi.kmu.ac.ir/Mobile",
  //kerman2
  // MAINURL: "https://apiKermanasayar.asayab.com/api/",
  // HUBURL: "https://apiKermanasayar.asayab.com",
  // HUBURL2: "https://apiKermanasayar.asayab.com/Mobile",
};
export default Constants;
